'use client';
import { Box, Container, Heading, Text } from '@chakra-ui/react';
import React from 'react';

import Image from '@/app/_components/Image';
import { directusImageLoader } from '@/utils/loaders';

import Styles from './SubBanner.module.scss';

type Props = {
  bannerImage?: string | undefined | null;
  heading?: string;
  description?: string;
};

const SubBannerSection = ({ bannerImage, heading, description }: Props) => {
  return (
    <Box className={Styles.bannerWrapper}>
      <Box className={Styles.bannerImage}>
        <Image
          src={bannerImage ?? ''}
          loader={directusImageLoader}
          width={1800}
          height={284}
          alt={heading ?? ''}
          title={heading ?? ''}
        />
      </Box>

      <Container
        maxW={'1280'}
        width={'100%'}
        className={Styles.bannerContentWrapper}
      >
        <Box className={Styles.bannerContent}>
          <Box className={Styles.headingElement}>
            <Heading
              as="h2"
              className={Styles.titleMd}
              marginBottom={{ base: 4, md: 4 }}
            >
              {heading}
            </Heading>
          </Box>
          <Text className={Styles.bannerText}>{description}</Text>
        </Box>
      </Container>
    </Box>
  );
};

export default SubBannerSection;
